/**
 * SB6-ANA-CACHE-03 — React read/control surface over the cache manifest.
 *
 * `useCacheManifest` is a `useSyncExternalStore` subscription to the manifest's
 * snapshot; it re-renders consumers (StorageSettings rows, the Data
 * Acquisitions cached-% cell, the dataset-header pin toggle) whenever a dataset
 * is recorded, touched-with-emit, pinned, cleared, or evicted. It also hydrates
 * the manifest on first mount so a freshly-loaded page reflects the persisted
 * state (the Friday→Monday case — AC1).
 *
 * `useCacheManifestEntry(id)` is a convenience selector for a single dataset.
 */
import { useEffect, useSyncExternalStore } from "react";
import { cacheManifest, type DatasetManifest } from "./cacheManifest.js";

export function useCacheManifest(): DatasetManifest[] {
  useEffect(() => {
    void cacheManifest.hydrate();
  }, []);
  return useSyncExternalStore(
    cacheManifest.subscribe,
    cacheManifest.getSnapshot,
    cacheManifest.getSnapshot,
  );
}

export function useCacheManifestEntry(
  dataAcquisitionId: string | null | undefined,
): DatasetManifest | undefined {
  const all = useCacheManifest();
  if (!dataAcquisitionId) return undefined;
  return all.find((m) => m.dataAcquisitionId === dataAcquisitionId);
}
